<template>
  <div :class="{'client-font-size': mode === 'Client'}" class="home section-container">
    <div class="invoiceNotPayed" v-if="invoiceNotPayed && mode === 'Kitchen'">
      <p>Va rugam sa va achitati facturile!!!</p>
    </div>
    <template v-if="!noToken">
      <template v-if="mode === 'Kitchen'">
        <div class="header">
          <div class="header__btnWrap">
            <button class="NEW withBG" :class="activeBtnName==1? 'active': ''" @click="changeListOfShowing(1, 0, 0, 0, 1);">{{lang.headerBtn1}} (<span>{{ordersNew.length}}</span>)</button>
          </div>
          <div class="header__btnWrap">
            <button class="PROCESSING withBG" :class="activeBtnName==2? 'active': ''" @click="changeListOfShowing(0, 1, 0, 0, 2);" style="border-left: 0;">{{lang.headerBtn2}} (<span>{{ordersProcessing.length}}</span>)</button>
          </div>
          <div class="settings">
            <div class="icon-settings PROCESSING" style="padding: auto; width: 25px; height: 25px;" @click="openSettingsModal();"></div>
          </div>
          <!-- <div class="selectLang icon-settings" :class="langSelected">
            <select @change="langChange($event)">
              <option v-for="sl in allLang" :selected="langSelected == sl ? true : false " :value="sl" :class="sl" >{{sl}}</option>
            </select>
            <span></span>
          </div> -->
        </div>
        <div class="content">
          <Orders @deleteFromOrders="onDeleteFromOrders"
                  @statusChanged="statusChanged"
                  :lang="lang" 
                  :use_fiscal_net="use_fiscal_net"
                  :fiscal_ip="fiscal_ip"
                  :order_statuses="listDefaults.order_statuses"
                  :orders="listOfShowing"
                  :mode="mode">
          </Orders>
        </div>
        <div class="footer">
          <div class="footer__btnWrap">
            <button class="NEW withBG" :class="activeBtnName==3? 'active': ''" @click="changeListOfShowing(1, 1, 0, 0, 3);">{{lang.footerBtn1}}  ({{ordersNew.length + ordersProcessing.length }})</button>
          </div>
          <div class="footer__btnWrap">
            <button class="PREPARED withBG" :class="activeBtnName==4? 'active': ''" style="border-left: 0; border-right: 0;" @click="changeListOfShowing(0, 0, 1, 0, 4);">{{lang.footerBtn2}} ({{ordersPrepared.length}})</button>
          </div>
          <div class="footer__btnWrap">
            <button class="OLD withBG" :class="activeBtnName==5? 'active': ''" @click="changeListOfShowing(0, 0, 0, 1, 5);">{{lang.footerBtn3}}  ({{ordersOld.length}})</button>
          </div>
        </div>
      </template>
      <template class="client-font-size" v-if="mode === 'Client'">
        <div class="header">
          <div class="header__btnWrap">
            <button class="preparing-client withBG" :class="activeBtnName==1? 'active': ''" @click="changeListOfShowing(0, 1, 1, 0, 1);">{{lang.preparing}} (<span>{{ordersProcessing.length}}</span>)</button>
          </div>
          <div class="header__btnWrap">
            <button class="prepared-client withBG" :class="activeBtnName==2? 'active': ''" @click="changeListOfShowing(0, 1, 1, 0, 2);" style="border-left: 0;">{{lang.prepared}} (<span>{{ordersPrepared.length}}</span>)</button>
          </div>
        </div>
        <div class="content">
          <Orders 
            @deleteFromOrders="onDeleteFromOrders"
            @statusChanged="statusChanged"
            :lang="lang"
            :use_fiscal_net="use_fiscal_net"
            :fiscal_ip="fiscal_ip"
            :order_statuses="listDefaults.order_statuses"
            :orders="listOfShowing"
            :mode="mode">
          </Orders>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="center">
        <h1>{{lang.errorNotValidUrl}}</h1>
        <h3>{{lang.enterCode}}: <input class="input-font-size" type="text" v-model="screen" v-on:keyup.enter="putTheToken"></h3>
      </div>
    </template>

    <modal name="modalStartApp">
      <div class="modal-overlay" @click="handleClickOutside">
        <div class="modalStartAppContainer">
          <div class="title">
            <h2>{{lang.right.question}}</h2>
          </div>
          <button @click="setFirstInteraction()">{{lang.right.btn}}</button>
        </div>
      </div>
    </modal>

    <modal name="settings">
      <div class="settingsContainer">
        <div class="title">
          <h2>{{ lang.settings }}</h2>
          <h4 v-if="location">{{ location.name }}</h4>
        </div>

        <div class="settingsRow icon-settings" :class="langSelected">
          <span>Select Language</span>
          <select @change="langChange($event)">
            <option v-for="sl in allLang" :selected="langSelected == sl" :value="sl" :class="sl">{{sl}}</option>
          </select>
          <span></span>
        </div>

        <div v-if="location" class="settingsRow">
          <span>{{ lang.delivery }}</span>
          <label class="switch">
            <input type="checkbox" @click="changeDeliveryMethodStatusRequest('delivery', !location.delivery)" v-model="location.delivery">
            <span class="slider round"></span>
          </label>
        </div>

        <div v-if="location" class="settingsRow">
          <span>{{ lang.pickUp }}</span>
          <label class="switch">
            <input type="checkbox" @click="changeDeliveryMethodStatusRequest('pick_up', !location.pickUp)" v-model="location.pickUp">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </modal>
  </div>  
</template>

<script>
  import Orders from '@/views/Orders';
  const axios = require('axios')
  export default {
    components:{
      'Orders': Orders
    },  
    name: "Home",
    data() {
      return {
        invoiceNotPayed: false,
        firstInteraction: false,
        requestInterval: {},
        loading: true,
        noReloadOneTime: 1,
        listDefaults: [],
        modalStartApp: 0,
        myAudio: [],
        isSoundRunning: 0,
        screen: "",
        noToken : 1,
        activeBtnName: 3,
        flagFirstReq: 1,
        page: '1',
        lang: null,
        allLang: null,
        langSelected: null,
        ordersNew: [],
        ordersProcessing: [],
        ordersPrepared: [],
        ordersOld: [],
        listOfShowing: [],
        use_fiscal_net: false,
        fiscal_ip: '',
        mode: 'Client',
        p1: 1, //ordersNew
        p2: 1, //ordersProcessing
        p3: 0, //ordersPrepared
        p4: 0, //ordersOld,
        location: null,
        handleDeliveryMethod: null,
      }
    },
    created() {
      this.setFontSize(20);
      this.getListDefaults();
      this.myAudio = new Audio("alarm.mp3");
      this.myAudio.loop = true;
      this.lang = window.__LANG;
      this.allLang = window.__AllLang;
      this.langSelected = window.langSelected;
      if (!!this.$route.query.screen) {
        this.modalStartApp = 1;
        localStorage.setItem('screen', this.$route.query.screen);
        this.getDataInterval();
      } else {
        this.noToken = 1;
        if (localStorage.getItem('screen')) {
          this.screen = localStorage.getItem('screen');
          this.putTheToken();
        }
      }
      if (this.$route.query.page) {
        this.page = this.$route.query.page;
      }
    },
    methods: {
      handleClickOutside () {
        // block clicks outside of modal
      },
      openSettingsModal () {
        this.$modal.show('settings');
      },
      handleMethodChange (deliveryMethod) {
        this.handleDeliveryMethod = deliveryMethod;
        this.$modal.hide('settingsContainer');
        this.$modal.show('chnageDeliveryMethodStatus');
      },
      changeDeliveryMethodStatusRequest (deliveryMethod, enabled) {
        let url = 'noauth/order-screen/delivery-method';

        let data = {
          screenToken: localStorage.getItem('screen'),
          deliveryMethod: deliveryMethod,
          enabled: enabled
        };

        this.apiRequest(url, "PUT", data, (response) => {
          // if (response.status) {
          //   this.$modal.show('settingsSuccess');
          // } else {
          //   this.$modal.show('settingsError');
          // }
        })
      },
      setFirstInteraction() {
        this.firstInteraction = true;
        this.$modal.hide('modalStartApp');
      },
      onDeleteFromOrders(orderid) {
        const ord = this.listOfShowing.find( ({ id }) => id === orderid );
        this.listOfShowing.splice( this.listOfShowing.indexOf(ord) , 1);
        this.noReloadOneTime = 0;
      },
      langChange(event) {
        const selectedLang = event.target.value;
        window.langSelected = selectedLang;

        window.__LANG = window.__LANG_Obj[window.langSelected]; 
        this.lang = window.__LANG;
        this.langSelected = window.langSelected;
      },
      startApp() {
        this.$modal.hide('modalStartApp');
        this.getDataInterval();
      },
      makeSound (sound) {
        if (sound && this.firstInteraction) {
          if (!this.isSoundRunning) {
            this.myAudio.play();
          }
          this.isSoundRunning = 1;
        } else {
          this.isSoundRunning = 0;
          this.myAudio.pause();
        }
      },
      putTheToken() {
        this.stopRequest();
        this.$router.push({path:'/', query:{screen: this.screen}});
        location.reload();
      },
      goToLogin() {
        this.stopRequest();
        localStorage.removeItem('screen');
        this.$router.push({path:'/'});
        location.reload();
      },
      setupStream() {
        let sourceURL = process.env.VUE_APP_API_URL + 'noauth/orders/' + localStorage.getItem('screen') 
        if (this.$route.query.store_id) {
          sourceURL = sourceURL + "&store_id=" + this.$route.query.store_id
        }
        let es = new EventSource(sourceURL)
        let self = this;
        es.addEventListener('message', event => {
          this.noToken = 0;
          if (self.noReloadOneTime) {
            self.noToken = 0;
            let data = JSON.parse(event.data)
            self.mode = data.mode
            
            if (data.mode === 'Client') {
              window.langSelected = data.lang;
            }
            window.__LANG = window.__LANG_Obj[window.langSelected]; 
            this.lang = window.__LANG;
            this.langSelected = window.langSelected;

            self.ordersNew = data.news
            self.ordersProcessing = data.incomings
            self.ordersPrepared = data.prepared
            self.ordersOld = data.old
            if (self.flagFirstReq) {
              self.listOfShowing = self.ordersNew;
              self.flagFirstReq = 0;
            }
            if (self.ordersNew.length) {
              self.makeSound(1);
            }else {
              self.makeSound(0);
            }
            if (this.mode === 'Client') {
              self.changeListOfShowing(0, 1, 1, 0, 2);

            } else {
              self.changeListOfShowing(self.p1,self.p2,self.p3,self.p4,self.activeBtnName);
            }
          }
          this.noReloadOneTime = 1;
          this.loading = false;
        }, false);
        es.addEventListener('error', event => {
          // this.noToken = 1;
          self.goToLogin()
          if (event.readyState == EventSource.CLOSED) {
            // console.log('Event was closed')
            // console.log(EventSource)
          }
        }, false)
      },
      statusChanged(data) {
        this.stopRequest()
        this.getDataInterval()
      },
      getDataInterval() {
        this.getData();
        
        this.requestInterval = setInterval(() => {
          this.getData();
        }, 1000 * 15);
      },
      getData () {
        let sourceURL = process.env.VUE_APP_API_URL + 'noauth/orders/' + localStorage.getItem('screen');

        axios
          .get(sourceURL)
          .then((response) => {
            if (response && response.data && response.data.status) {
              this.noToken = 0;
              if (this.noReloadOneTime) {
                this.noToken = 0;
                let data = response.data.data

                this.location = data.location

                this.mode = data.mode
                if (data.mode === 'Client') {
                  window.langSelected = data.lang;
                }
                window.__LANG = window.__LANG_Obj[window.langSelected]; 
                this.lang = window.__LANG;
                this.langSelected = window.langSelected;


                if (data.is_inactive) {
                  this.invoiceNotPayed = true;
                } else {
                  this.invoiceNotPayed = false;
                }

                this.ordersNew = data.news
                this.ordersProcessing = data.incomings
                this.ordersPrepared = data.prepared
                this.ordersOld = data.old
                this.use_fiscal_net = data.use_fiscal_net
                this.fiscal_ip = data.fiscal_ip

                if (this.flagFirstReq) {
                  this.listOfShowing = this.ordersNew;
                  this.flagFirstReq = 0;
                }

                if (!this.firstInteraction && this.mode === 'Kitchen') {
                  this.$modal.show('modalStartApp');
                }

                if (this.ordersNew.length) {
                  this.printNewOrder(this.ordersNew);
                  this.makeSound(1);
                } else {
                  this.makeSound(0);
                }

                if (this.mode === 'Client') {
                  this.changeListOfShowing(0, 1, 1, 0, 2);
                } else {
                  this.changeListOfShowing(this.p1, this.p2, this.p3, this.p4, this.activeBtnName);
                }
              }
              this.noReloadOneTime = 1;
              this.loading = false;
            }
          })
      },
      getListDefaults() {
        let url = process.env.VUE_APP_GENERAL_API_URL + 'listdefaults';
        this.callUrl(url, (res) => {
          this.listDefaults = res.data.data[0];
        });
      },
      callUrl: function(url, callback) {
        axios
          .get(url)
          .then(function (response) {
            callback(response);
          })
          .catch(function (error) {
            callback(0);
          })
      },
      formatValueFloat(value) {
        return parseFloat(value).toFixed(2)
      },
      stopRequest() {
        if (this.requestInterval) {
          clearInterval(this.requestInterval)
        }
      },
      changeListOfShowing(ordersNew, ordersProcessing, ordersPrepared, ordersOld, activeBtnName=0 ) {
        let list = [];
        this.p1 = ordersNew
        this.p2 = ordersProcessing
        this.p3 = ordersPrepared
        this.p4 = ordersOld
        this.activeBtnName = activeBtnName;
        if (ordersNew) {
          this.ordersNew.forEach(element => 
            list.push(element)
          );
        }
        if (ordersProcessing) {
          this.ordersProcessing.forEach(element => 
            list.push(element)
          );
        }
        if (ordersPrepared) {
          this.ordersPrepared.forEach(element => 
            list.push(element)
          );
        }
        if (ordersOld) {
          this.ordersOld.forEach(element => 
            list.push(element)
          );
        }
        list = this.bubbleSort(list);
        this.listOfShowing = list;
      },
      printNewOrder(ordersList) {
        let i = 0;
        while (i < ordersList.length) {
          if (ordersList[i].hasOwnProperty('print')) {
            this.postMessageToParent(ordersList[i]);
          }
          i++;
        }
      },
      bubbleSort(a) {
        let swapped;
        do {
          swapped = false;
          for (let i=0; i < a.length-1; i++) {
            if (a[i].pickup_datetime > a[i+1].pickup_datetime) {
              let temp = a[i];
              a[i] = a[i+1];
              a[i+1] = temp;
              swapped = true;
            }
          }
        } while (swapped);
        return a;
      },
    }
  }
</script>

<style scoped lang="scss">
  .invoiceNotPayed {
    position: absolute;
    width: 100%;
    height: 100%;
    background: red;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    z-index: 999;
    p {
      padding: 50px;
    }
  }
  .modalStartAppContainer {
    width: 70%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: auto;
    button {
      background: #333;
      font-weight: 700;
      font-size: 20px;
    }
  }
  .section-container {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  .content {
    width: 100%;
    height: 100%;
    overflow: auto;
    h1 {
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 1.5em;
    }
  }
  .footer,
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header__btnWrap {
    width: calc(50%);
  }
  .selectLang {
    position: relative;
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #fff;
    font-weight: 700;

    select::-ms-expand {
      display: none;
    }
    select {
      background: none;
      border: none;
      color: inherit;
      font-weight: 700;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      width: 100%;
      text-align: center;
      height: 100%;
      padding: 0;
      padding-left: 7px;
      font-size: 17px;
      text-transform: uppercase;

      border-top: 1px solid #333;
      border-bottom: 1px solid #333;
      border-right: 1px solid #333;
    }
    >span {
      pointer-events: none;
      position: absolute;
      right: 0;
      top: calc(50% - 10px);
      width: 50px;
      height: 20px;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
    }
    // https://www.phoca.cz/cssflags/
    &.ro >span {
      padding-left: 25px;
      background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NTAgMzAwIj4NCjxwYXRoIGZpbGw9IiMwMDJiN2YiIGQ9Im0wLDBoMTUwdjMwMGgtMTUweiIvPg0KPHBhdGggZmlsbD0iI2ZjZDExNiIgZD0ibTE1MCwwaDE1MHYzMDBoLTE1MHoiLz4NCjxwYXRoIGZpbGw9IiNjZTExMjYiIGQ9Im0zMDAsMGgxNTB2MzAwaC0xNTB6Ii8+DQo8L3N2Zz4NCg==);
    }
    &.es >span {
      padding-left: 25px;
      background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3NTAgNTAwIj4NCjxwYXRoIGZpbGw9IiNjNjBiMWUiIGQ9Im0wLDBoNzUwdjUwMGgtNzUweiIvPg0KPHBhdGggZmlsbD0iI2ZmYzQwMCIgZD0ibTAsMTI1aDc1MHYyNTBoLTc1MHoiLz4NCjwvc3ZnPg0K);
    }
    &.en >span {
      padding-left: 25px;
      background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjM1IDY1MCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KPGRlZnM+DQo8ZyBpZD0idW5pb24iPg0KPHVzZSB5PSItLjIxNiIgeGxpbms6aHJlZj0iI3g0Ii8+DQo8dXNlIHhsaW5rOmhyZWY9IiN4NCIvPg0KPHVzZSB5PSIuMjE2IiB4bGluazpocmVmPSIjczYiLz4NCjwvZz4NCjxnIGlkPSJ4NCI+DQo8dXNlIHhsaW5rOmhyZWY9IiNzNiIvPg0KPHVzZSB5PSIuMDU0IiB4bGluazpocmVmPSIjczUiLz4NCjx1c2UgeT0iLjEwOCIgeGxpbms6aHJlZj0iI3M2Ii8+DQo8dXNlIHk9Ii4xNjIiIHhsaW5rOmhyZWY9IiNzNSIvPg0KPC9nPg0KPGcgaWQ9InM1Ij4NCjx1c2UgeD0iLS4yNTIiIHhsaW5rOmhyZWY9IiNzdGFyIi8+DQo8dXNlIHg9Ii0uMTI2IiB4bGluazpocmVmPSIjc3RhciIvPg0KPHVzZSB4bGluazpocmVmPSIjc3RhciIvPg0KPHVzZSB4PSIuMTI2IiB4bGluazpocmVmPSIjc3RhciIvPg0KPHVzZSB4PSIuMjUyIiB4bGluazpocmVmPSIjc3RhciIvPg0KPC9nPg0KPGcgaWQ9InM2Ij4NCjx1c2UgeD0iLS4wNjMiIHhsaW5rOmhyZWY9IiNzNSIvPg0KPHVzZSB4PSIuMzE1IiB4bGluazpocmVmPSIjc3RhciIvPg0KPC9nPg0KPGcgaWQ9InN0YXIiPg0KPHVzZSB4bGluazpocmVmPSIjcHQiIHRyYW5zZm9ybT0ibWF0cml4KC0uODA5MDIgLS41ODc3OSAuNTg3NzkgLS44MDkwMiAwIDApIi8+DQo8dXNlIHhsaW5rOmhyZWY9IiNwdCIgdHJhbnNmb3JtPSJtYXRyaXgoLjMwOTAyIC0uOTUxMDYgLjk1MTA2IC4zMDkwMiAwIDApIi8+DQo8dXNlIHhsaW5rOmhyZWY9IiNwdCIvPg0KPHVzZSB4bGluazpocmVmPSIjcHQiIHRyYW5zZm9ybT0icm90YXRlKDcyKSIvPg0KPHVzZSB4bGluazpocmVmPSIjcHQiIHRyYW5zZm9ybT0icm90YXRlKDE0NCkiLz4NCjwvZz4NCjxwYXRoIGZpbGw9IiNmZmYiIGlkPSJwdCIgZD0iTS0uMTYyNSwwIDAtLjUgLjE2MjUsMHoiIHRyYW5zZm9ybT0ic2NhbGUoLjA2MTYpIi8+DQo8cGF0aCBmaWxsPSIjYmYwYTMwIiBpZD0ic3RyaXBlIiBkPSJtMCwwaDEyMzV2NTBoLTEyMzV6Ii8+DQo8L2RlZnM+DQo8cGF0aCBmaWxsPSIjZmZmIiBkPSJtMCwwaDEyMzV2NjUwaC0xMjM1eiIvPg0KPHVzZSB4bGluazpocmVmPSIjc3RyaXBlIi8+DQo8dXNlIHk9IjEwMCIgeGxpbms6aHJlZj0iI3N0cmlwZSIvPg0KPHVzZSB5PSIyMDAiIHhsaW5rOmhyZWY9IiNzdHJpcGUiLz4NCjx1c2UgeT0iMzAwIiB4bGluazpocmVmPSIjc3RyaXBlIi8+DQo8dXNlIHk9IjQwMCIgeGxpbms6aHJlZj0iI3N0cmlwZSIvPg0KPHVzZSB5PSI1MDAiIHhsaW5rOmhyZWY9IiNzdHJpcGUiLz4NCjx1c2UgeT0iNjAwIiB4bGluazpocmVmPSIjc3RyaXBlIi8+DQo8cGF0aCBmaWxsPSIjMDAyODY4IiBkPSJtMCwwaDQ5NHYzNTBoLTQ5NHoiLz4NCjx1c2UgeGxpbms6aHJlZj0iI3VuaW9uIiB0cmFuc2Zvcm09Im1hdHJpeCg2NTAgMCAwIDY1MCAyNDcgMTc1KSIvPg0KPC9zdmc+DQo=);
    }
    &.gr >span {
      padding-left: 25px;
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODEwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNyAxOCIgaGVpZ2h0PSI1NDAiPg0KPHBhdGggZmlsbD0iIzAwMDA4MCIgZD0ibTAsMGgyN3YxOGgtMjd6Ii8+DQo8cGF0aCBmaWxsPSIjZmZmIiBkPSJtNCwwIDIsMCAwLDQgNCwwIDAsMi00LDAgMCw0IDIxLDAgMCwyLTI3LDAgMC0yIDQsMCAwLTQtNCwwIDAtMiA0LDAgMC00em02LDIgMTcsMCAwLDItMTcsMCAwLTJ6bTAsNCAxNywwIDAsMi0xNywwIDAtMnptLTEwLDQgMCwyIDAtMnptMCw0IDI3LDAgMCwyLTI3LDAgMC0yeiIvPg0KPC9zdmc+DQo=);
    }
    &.cz >span {
      padding-left: 25px;
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAwIiB4…jMTE0NTdlIiBkPSJtMywybC0zLTJ2NHoiLz4NCjwvc3ZnPg0K);
    }
    
    option {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
    }
  }
  .footer__btnWrap {
    width: 33.33%;
  }
  .center {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
</style>
<style lang="scss">
  button {
    cursor: pointer;

    width: 100%;
    border: 1px solid #333;
    
    padding: 10px;
    font-size: 1em;
    font-weight: 500;
    color: #fff;
    background: #333;
    @media screen and (max-width: 500px) {
      font-size: 0.8rem;
    }
    @media screen and (max-width: 400px) {
      font-size: 0.6rem;
    }
    span {
      font-weight: 700;
      // font-size: 1.3em;
    }
    &.active {
      font-weight: bold;
      text-decoration: underline;
      // color: black;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
  .NEW {
    background: #68b3c8;
    &.active {
      background: rgba(104, 179, 200, 0.7);
    }
  }
  .PROCESSING {
    color: #f3bb45;
    background: #fff;
    font-weight: 700;
    &.withBG {
      color: #fff;
      background: #f3bb45;
      font-weight: 400;
    }
    &.active {
      background: rgba(243, 187, 69, 0.7);
      color: #000;
    }
    &.orderBox__time {
      background: #f3bb45;
      font-weight: 400;
    }
  }
  .PREPARED {
    color: #5e35b1;
    background: #fff;
    font-weight: 700;
    &.withBG {
      color: #fff;
      background: #5e35b1;
      font-weight: 400;
    }
    &.active {
      background: rgba(94, 53, 177, 0.7);
      color: #000;
    }
    &.orderBox__time {
      background: #5e35b1;
      font-weight: 400;
    }
  }
  .CANCELED {
    color: #eb5e28;
    background: #fff;
    font-weight: 700;
    &.withBG {
      color: #fff;
      background: #eb5e28;
      font-weight: 400;
    }
    &.active {
      background: rgba(235, 94, 40, 0.7);
      color: #000;
    }
    &.orderBox__time {
      background: #eb5e28;
      font-weight: 400;
    }
  }
  .DELIVERED {
    color: #7ac29a;
    background: #fff;
    font-weight: 700;
    &.withBG {
      color: #fff;
      background: #7ac29a;
      font-weight: 400;
    }
    &.active {
      background: rgba(122, 194, 154, 0.7);
      color: #000;
    }
    &.orderBox__time {
      background: #7ac29a;
      font-weight: 400;
    }
  }
  .TRANSPORT {
    color: #0f566a;
    background: #fff;
    font-weight: 700;
    &.withBG {
      color: #fff;
      background: #0f566a;
      font-weight: 400;
    }
    &.active {
      background: rgba(15, 86, 106, 0.7);
      color: #000;
    }
    &.orderBox__time {
      background: #0f566a;
      font-weight: 400;
    }
  }
  .OLD {
    color: #eb5e28;
    background: #fff;
    font-weight: 700;
    &.withBG {
      color: #fff;
      background: #eb5e28;
      font-weight: 400;
    }
    &.active {
      background: rgba(235, 94, 40, 0.7);
      color: #000;
    }
    &.orderBox__time {
      background: #eb5e28;
      font-weight: 400;
    }
  }
  .preparing-client {
    color: #f3bb45;
    background: #000;
    font-weight: 700;
    &.withBG {
      color: #000;
      background: #f3bb45;
      font-weight: 400;
    }
    &.active {
      // background: rgba(243, 187, 69, 0.7);
      // color: #000;
      text-decoration: none;
    }
    &.orderBox__time {
      background: #f3bb45;
      font-weight: 400;
    }
  }

  .prepared-client {
    color: #7ac29a;
    background: #000;
    font-weight: 700;
    &.withBG {
      color: #000;
      background: #7ac29a;
      font-weight: 400;
    }
    &.active {
      // background: rgba(122, 194, 154, 0.7);
      // color: #000;
      text-decoration: none;
    }
    &.orderBox__time {
      background: #7ac29a;
      font-weight: 400;
    }
  }

  .right-container{
    width: 50%;
  }

  .left-container{
    width: 50%;
  }

  .custom-row {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 5px 10px;
    background-color: #e3dede;
    text-align: center;
    margin-left: 5px;
  }

  .order-done .custom-row{
    background-color: red;
    color:#fff;
    margin-left:0px;
    border: 1px solid red;
  }

  .container {
    display: flex;
    flex-wrap: wrap;
  }

  .column {
    width: 50%;
  }

  .container .column .order-container {
    display: inline-block;
    padding: 5px;
    margin-top: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    color: white;
    border-radius: 8px;
  }

  .container .column .status-2 {
    background-color: #7ac29a;
    color:#000;
    margin-left:10px;
    margin-right: 10px;
    padding-left:10px;
    padding-right: 10px;
    border: 1px solid #7ac29a;
    span {
      font-weight: 600;
    }
  }

  .container .column .status-1 {
    background-color: #f3bb45;
    color:#000;
    margin-left:10px;
    margin-right: 10px;
    padding-left:10px;
    padding-right: 10px;
    border: 1px solid #f3bb45;
    span {
      font-weight: 600;
    }
  }
  

  /* Default font size */
  .client-font-size {
    font-size: 1.6rem;
  }

  /* Media query for smaller devices */
  @media (max-width: 600px) {
    .client-font-size {
      font-size: 1rem;
    }
    .order-number-size {
      font-size: 2rem !important;
    }
  }

  // /* Media query for larger devices */
  @media (min-width: 1200px) {
    .client-font-size {
      font-size: 2rem;
    }
    .order-number-size {
      font-size: 3rem !important;
    }
  }

  @media (min-width: 1600px) {
    .client-font-size {
      font-size: 2.6rem;
    }
    .order-number-size {
      font-size: 4rem !important;
    }
  }

  @media (min-width: 2000px) {
    .client-font-size {
      font-size: 3rem;
    }
    .order-number-size {
      font-size: 4.5rem !important;
    }
  }

  @media (min-width: 2400px) {
    .client-font-size {
      font-size: 4rem;
    }
    .order-number-size {
      font-size: 5.5rem !important;
    }
  }

  @media (min-width: 3000px) {
    .client-font-size {
      font-size: 6rem;
    }
    .order-number-size {
      font-size: 8.5rem !important;
    }
  }

  .input-font-size {
    font-size: 25px;
    text-align: center;
  }

  .show-loader{
    position: absolute;
    display: inline-block;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;

  .el-loading-spinner{
     z-index: 2001;
  }
  &:after{
    content: '';
    display: inline-block;
    position: absolute;
    width: 100%;
    margin: auto;
    top:0;
    bottom: 0;
    left: -15px;
    right: -15px;
    background: rgba(255,255,255,0.5);
    z-index: 2000;
    border-radius:2px;
  }
}

.hide-loader{
  .el-loading-spinner{
    display: none;
  }
}

div.settings {
  .icon-settings {
    background-image: url("../assets/gear.png");
    background-size: cover; /* Ensure the image covers the element */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Prevent repeating the image */
    margin-top: 5px;
    margin-bottom: 5px;
  }
  border: 1px solid #333;
  position: relative;
  height: 96% !important;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  font-weight: 700;
}

.settingsContainer {
  padding: 20px;
  font-size: 1.4rem !important;
  select {
    width: 50px;
    height: 30px;
    font-size: 20px;
    margin-left: 130px;
  }
}

div.settingsContainer .title {
  h2 {
    margin: 0;
  }
  h4 {
    margin: 10px;
  }
  text-align: center;
  // margin-bottom: 20px;
}

.locationNameRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.locationName {
  font-size: 18px;
}

.closeButton {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.selectLang {
  margin-bottom: 20px;
}

.settingsRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 36px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 30px;
  width: 30px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:checked + .slider:before {
  transform: translateX(14px);
}

.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}

.width25 {
  width: 25%;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
